exports = module.exports = require("../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n/* Special styling for type=range and type=color input */\ninput.form-control[type=\"range\"],\ninput.form-control[type=\"color\"] {\n    height: 2.25rem;\n}\ninput.form-control.form-control-sm[type=\"range\"],\ninput.form-control.form-control-sm[type=\"color\"] {\n    height: 1.9375rem;\n}\ninput.form-control.form-control-lg[type=\"range\"],\ninput.form-control.form-control-lg[type=\"color\"] {\n    height: 3rem;\n}\n/* Less padding on type=color */\ninput.form-control[type=\"color\"] {\n    padding: 0.25rem 0.25rem;\n}\ninput.form-control.form-control-sm[type=\"color\"] {\n    padding: 0.125rem 0.125rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/css-loader?{"minimize":false,"sourceMap":false}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/style-compiler?{"id":"data-v-ea776306","scoped":false,"hasInlineConfig":true}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=styles&index=0!/home/alarmplan/staging/shared/frontend/~/bootstrap-vue/es/components/form-input/form-input.vue
// module id = 805
// module chunks = 0